module.exports = __webpack_public_path__ + "static/media/item2.366924ca.png";